// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"08e6b36c","99":"b0a07042","232":"c181dcbf","252":"24868dd9","419":"ae8a500d","563":"d46d5e29","774":"33be8f0a","883":"5bee153c","942":"1f56ffd9","985":"6bb66ef3"}[chunkId] + ".chunk.js";
};